import angular from 'angular';

import styles from './styles.css';

import routes from './routes';

import template from './template.html'
import controller from './controller'

export default angular.module('app.main.panel.module.pictures', [])
	.config(routes)
	.component('pictures', {
		template: template,
		controller: controller,
		controllerAs: 'ctrl',
		bindings: {
			config: '<',
			status: '<',
			connected: '<',
			panel: '='
			//onUpdate: '&'
		}
	})
	.name;


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/pictures.component/index.js
 **/